import React, { useState } from 'react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetFooter,
  Button,
  Input,
  Label,
  Textarea,
} from 'lift-ui';
import '../../iam-support.styles.scss';

interface CreateGroupSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreate: (name: string, description?: string) => void;
  isSubmitting?: boolean;
}

const CreateGroupSheet: React.FC<CreateGroupSheetProps> = ({
  open,
  onOpenChange,
  onCreate,
  isSubmitting = false,
}) => {
  const [groupName, setGroupName] = useState('');
  const [description, setDescription] = useState('');

  const handleCreate = () => {
    if (groupName.trim()) {
      onCreate(groupName.trim(), description.trim() || undefined);
      resetForm();
      onOpenChange(false);
    }
  };

  const resetForm = () => {
    setGroupName('');
    setDescription('');
  };

  const handleClose = () => {
    resetForm();
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" size="md" className="iam-support-sheet flex flex-col h-full">
        <SheetHeader>
          <SheetTitle>Create User Group</SheetTitle>
          <SheetDescription>
            Create a new user group. You can add members and assign permissions after creation.
          </SheetDescription>
        </SheetHeader>
        <div className="iam-support-dialog-form flex-1 overflow-y-auto">
          <div className="iam-support-form-field">
            <Label htmlFor="group-name">Group Name *</Label>
            <Input 
              id="group-name" 
              placeholder="Enter group name (e.g., Engineering, Marketing)"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </div>
          <div className="iam-support-form-field iam-support-form-field--description">
            <Label htmlFor="group-description">Description</Label>
            <Textarea 
              id="group-description" 
              placeholder="Optional: Describe the purpose of this group"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </div>
        </div>
        <SheetFooter className="border-t pt-4 mt-4">
          <Button variant="outline" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button 
            variant="default" 
            onClick={handleCreate} 
            disabled={!groupName.trim() || isSubmitting}
          >
            {isSubmitting ? 'Creating...' : 'Create Group'}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default CreateGroupSheet;
